/// <amd-module name="Test/Analytics/TestResultsGrid/DetailedListSourceManager" />
import { IDetailedTestListSource } from "Test/Analytics/TestResultsGridCommon/Types";
import { DetailedTestListSourceService } from "Test/FilteringLogic/Services/DetailedTestListSourceService";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export class DetailedListSourceManager {
    constructor(private _pageContext: IVssPageContext) {}

    public async getDetailedListSourceManager(): Promise<IDetailedTestListSource> {
        const contributionService: IVssContributionService = this._pageContext.getService<IVssContributionService>("IVssContributionService");
        await contributionService.getContributionAsync("ms.vss-test-analytics-web.filtering-logic");

        const detailedListSourceManager = this._pageContext.getService<DetailedTestListSourceService>("DetailedTestListSourceService");
        if (detailedListSourceManager) {
            detailedListSourceManager.initialize(this._pageContext);
        }
        return detailedListSourceManager;
    }
}
